import React, { PureComponent } from 'react';

import Tooltip from './tooltip';
import HelpTooltip from './help-tooltip';

export default class FlyoutToggleItem extends PureComponent {
    static defaultProps = {
        tooltipPlacement: 'right'
    }

    handleClick = () => {
        this.props.onClick && this.props.onClick(this.props.id);
    }

    render() {
        return (
            <span className={'nav-item-inner nav-item-inner-no-gutter' + (this.props.disabled ? ' muted no-hover' : '') } onClick={this.handleClick}>
                <span className="nav-item-image">
                    <Tooltip placement={this.props.tooltipPlacement} disabled={this.props.tooltipDisabled} tooltip={this.props.label}>
                        <span className="nav-item-icon">{this.props.icon}</span>
                    </Tooltip>
                </span>

                <span className="nav-item-text">{this.props.label}</span>

                {
                    this.props.notifications ? (
                        <span className="nav-item-notifications notification-bubble">{this.props.notifications}</span>
                    ) : null
                }

                {
                    this.props.disabled ? <HelpTooltip>{this.props.disabled}</HelpTooltip> : null
                }
            </span>
        )
    }
}